<div class="container translations">
    @if (!onlyTable) {
        <div>
            <h4>{{'general.clients' | translateWithKeys}}</h4>
            <p>{{'category-creation.clients_section_description' | translateWithKeys}}</p>
        </div>
        <hr>
    }
    <div class="scroll-table">
        @if (selectedContentCreators?.length) {
            <app-table [dataSource]="selectedContentCreators" [table]="clientsTable" [isDeleted]="true"
            (toggleChanged)="checkSectionCompletion()" (selectedItems)="removeCreator($event.item)"></app-table>
        }
    </div>

    <div class="client-selector-container">
        <button mat-stroked-button (click)="openOverlay($event)" class="add-client-btn">
            <mat-icon class="icon" svgIcon="plus"></mat-icon>
            {{'general.add_client' | translateWithKeys}}
        </button>

        <ng-template #languageOverlay>
            <div class="custom-overlay">
                <mat-form-field appearance="outline" class="search-client">
                    <input matInput [(ngModel)]="searchTerm" (ngModelChange)="onSearchTermChange($event)" placeholder="{{'general.search' | translateWithKeys}}"/>
                </mat-form-field>

                <mat-selection-list (selectionChange)="selectCreator($event)" [multiple]="true">
                    <mat-list-option class="creator-select" [selected]="isCreatorSelected(creator)"
                        *ngFor="let creator of contentCreators" [value]="creator">
                        {{creator.username}}
                    </mat-list-option>
                </mat-selection-list>
            </div>
        </ng-template>
    </div>
</div>

<ng-template #editInstructorsTemplate let-element="element">
    <div class="flex vertical-center gap-8">
        @if (element?.instructors?.length) {
            @if(!element.__assignedCategories[0]?.instructor) {
                <button mat-icon-button (click)="openInstructorOverlay($event, element)">
                    <mat-icon class="icon" svgIcon="plus"></mat-icon>
                </button>
            } @else {
                {{ element.__assignedCategories[0]?.instructor }}
                <button mat-icon-button (click)="openInstructorOverlay($event, element)" class="pencil-btn">
                    <mat-icon class="pencil-icon" svgIcon="pencil_simple"></mat-icon>
                </button>
            }
        } @else {
            <span>{{'general.no_instructors' | translateWithKeys}}</span>
        }
    </div>
</ng-template>

<ng-template #editFormLinkTemplate let-element="element">
  <div class="flex vertical-center gap-8">
    @if (!element.__assignedCategories[0]?.formLink) {
      <button mat-icon-button (click)="openFormlinkModal(element.__assignedCategories[0])">
        <mat-icon class="icon" svgIcon="plus"></mat-icon>
      </button>
    } @else {
      <span
        class="formlink-ellipsis"
        [matTooltip]="element.__assignedCategories[0]?.formLink"
      >
        {{
          element.__assignedCategories[0]?.formLink | slice: 0:20
        }}
      </span>
      <button
        mat-icon-button
        (click)="openFormlinkModal(element.__assignedCategories[0])"
        class="pencil-btn"
      >
        <mat-icon class="pencil-icon" svgIcon="pencil_simple"></mat-icon>
      </button>
    }
  </div>
</ng-template>


<ng-template #instructorOverlay let-element="element">
  <div class="custom-overlay">
    <mat-selection-list
      (selectionChange)="selectInstructor($event, element.__assignedCategories[0])"
      [multiple]="false">
      <mat-list-option *ngFor="let instructor of element?.instructors" [value]="instructor">
        {{ instructor }}
      </mat-list-option>
    </mat-selection-list>
  </div>
</ng-template>
